export default __webpack_public_path__ + "static/prestashop-logo-6dbb0f20b9326ba6d91e969e8304fc43.png";